<template>
    <a :href="'https://maps.google.com/maps?q=&layer=c&cbll=' + lat + ',' + long + '&cbp=11,direction,0,0,0'"
       target="_blank" style="padding-right: 10px">
        <img src="/assets/img/street-view.png" style="height: 30px">
    </a>
</template>

<script>

export default {
    name: "GoogleEarthButton",
    props: {
        lat: {
            required: true
        },
        long: {
            required: true
        }
    }
}
</script>

<style scoped>

</style>
